module.exports = __webpack_public_path__ + "static/img/11.e5671ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/client_logo/11.jpg
// module id = Jwbn
// module chunks = 0